/**
 * Skeleton loader pour les pages pendant la vérification d'authentification
 * Affiche une structure grise animée au lieu d'un écran blanc
 */
export const PageSkeleton = () => (
  <div className="min-h-screen bg-gray-50 animate-pulse">
    {/* Header skeleton */}
    <div className="h-16 bg-gray-200 border-b border-gray-300" />
    
    {/* Content skeleton */}
    <div className="max-w-7xl mx-auto px-4 py-8">
      <div className="h-8 bg-gray-200 rounded w-1/4 mb-6" />
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
        <div className="h-32 bg-gray-200 rounded" />
        <div className="h-32 bg-gray-200 rounded" />
        <div className="h-32 bg-gray-200 rounded" />
      </div>
      <div className="h-96 bg-gray-200 rounded" />
    </div>
  </div>
);
